export default [
  {
    path: "/nomina-unidad",
    name: "nomina-unidad",
    component: () => import(/* webpackChunkName: "nomina-unidad" */ "../views/NominaUnidadView.vue"),
  },
  {
    path: "/historial-permisos/:idEmpleadoPuesto",
    name: "historial-permisos-empleado",
    component: () => import(/* webpackChunkName: "historial-permisos-empleado" */ "../views/HistorialPermisosView.vue"),
  },
  {
    path: "/estadistica-permisos",
    name: "estadistica-permisos",
    component: () => import(/* webpackChunkName: "estadistica-permisos" */ "../views/EstadisticaPermisosView.vue"),
  },
  {
    path: "/solicitud-funciones",
    name: "solicitud-funciones",
    component: () => import(/* webpackChunkName: "solicitud-funciones" */ "../views/ListadoSolicitudFunciones.vue"),
  },
  {
    path: "/solicitud-remover-funciones",
    name: "solicitud-remover-funciones",
    component: () => import(/* webpackChunkName: "solicitud-remover-funciones" */ "../views/ListadoSolicitudRemoverFunciones.vue"),
  },
  {
    path: "/generar-solicitud-funciones",
    name: "generar-solicitud-funciones",
    component: () => import(/* webpackChunkName: "generar-solicitud-funciones" */ "../views/GenerarSolicitudFunciones.vue"),
  },
  {
    path: "/generar-solicitud-funciones/ingresar/",
    name: "ingresar-funciones",
    component: () => import(/* webpackChunkName: "ingresar-funciones" */ "../views/IngresarFunciones.vue"),
  },
  {
    path: "/solicitud-funciones/detalle/:id",
    name: "detalle-solicitud-funciones",
    component: () => import(/* webpackChunkName: "detalle-solicitud-funciones" */ "../views/DetalleSolicitudAsignarFuncion.vue"),
  },
  {
    path: "/detalle-funcion",
    name: "detalle-funcion",
    component: () => import(/* webpackChunkName: "detalle-funcion" */ "../views/DetalleFuncion.vue"),
  },
  {
    path: "/generar-solicitud-remover-funciones",
    name: "generar-solicitud-remover-funciones",
    component: () => import(/* webpackChunkName: "generar-solicitud-remover-funciones" */ "../views/GenerarSolicitudRemoverFunciones.vue"),
  },
  {
    path: "/solicitud-remover-funciones/detalle/:id",
    name: "detalle-solicitud-remover-funciones",
    component: () =>
      import(
        /* webpackChunkName: "detalle-solicitud-remover-funciones" */ "../views/DetalleSolicitudRemoverFuncion.vue"
      ),
  },
];
